'use strict';

import $ from 'jquery';
import 'select2';
import { recaptchaUpdater } from '../../modules/recaptcha';

const rede = {
  settings: {
    _token: $('meta[name="csrf-token"]').attr('content'),
  },
  init() {
    recaptchaUpdater('profile');
  },
};

const s = rede.settings,
  _this = rede;

export default _this;
